import { useEffect } from 'react'

export type SetIsDirty = (isDirty: boolean) => void

export const useExternalIsDirty = (setIsDirty: SetIsDirty | undefined, isDirty: boolean) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: Only want this to run on dismount, not when setIsDirty changes
  useEffect(() => {
    return () => {
      setIsDirty?.(false)
    }
    // I only want this to run on dismount. If they are messing around with the "setIsDirty" function I don't want to
    // constantly call it and unset it.
  }, [])

  useEffect(() => {
    setIsDirty?.(isDirty)
  }, [isDirty, setIsDirty])
}
